<template>
  <div>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <div class="abanner">
        <img src="../../assets/images/help_1.jpg" alt="" />
        <p>帮助中心</p>
      </div>
      <div class="mt-30">
        <div class="seach">
          <el-input
            v-model="input"
            placeholder="请输入你要查询的问题"
            @keyup.enter.native="onSeach()"
          ></el-input>
          <button class="seachBtn" @click.prevent="onSeach()">搜索</button>
        </div>
        <div class="mt-20 fdw"> 
          <!--列表显示-->
          <div class="help_conent" v-for="(item,index) in list" :key="index" @click="onView(item)">
            <div class="garden">{{index+1}}</div> 
            <div class="help_text">
              <p>{{item.title}}</p>
              <p>{{item.descrption}}</p>
            </div>
          </div>
         
         <!--分页-->
           <Pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery.curPage"
            :limit.sync="listQuery.limit"
            @pageChange="pageChange"
          ></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import titleHead from "../../common/titleHead";
import {helpList} from '@/api/coment'
import Pagination from "../../components/Pagination";
export default {
  components: { titleHead ,Pagination},
  data() {
    return {
      headTitle: "帮助中心",
      input: "",
      list:[],
      listQuery: {
        page: 1,
        limit: 8,
      },
      total:0 //总条数,
    };
  },
  created(){
    this.getList();
    this.getMate();
  },
  methods: {
    //查看详情
    onView(row) {
      this.$router.push({
        path:"/help_detail",
        query:{id:row.id}
      });
    },
    //列表
    getList(){
      helpList(this.listQuery).then((res)=>{
        if(res.code ==0){
          this.list = res.page.list;
          this.total = res.page.totalCount;
        }
      }).catch((err)=>{});
    },
    onSeach(){
       this.listQuery.key = this.input;
       this.getList();
    },
    getMate(){
        var metas = document.getElementsByTagName("meta"); 
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
     },
    pageChange(item){
      this.listQuery["page"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getList();
    }
  },
};
</script>
<style scoped>
@import url('../../assets/css/coment.css');
.abanner{
    position: relative;
}
.abanner img {
  width: 100%;
}
.abanner p {
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  color: #ffffff;
  font-size: 30px;
  margin-left: -60px;
  margin-top: -20px;
}
.fdw{
  display: flex;
  justify-content: center;
}
.mt-20 {
  margin-top: 20px;
}
.seach {
  position: relative;
}
.seach >>> .el-input__inner {
  height: 66px;
  line-height: 66px;
}
.seachBtn {
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  height: 66px;
  width: 189px;
  color: #ffffff;
  background: #3ba84d;
}
.help_conent {
  width: 48%;
  padding: 20px 0px;

  display: flex;
  justify-content: left;
}
.help_text {
  margin-left: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dedede;
}
.help_text p:nth-child(1) {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.help_text p:nth-child(1):hover{
  cursor: pointer;
}
.help_text p:nth-child(2) {
  margin-top: 10px;
  font-size: 14px;
  line-height: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/view/other/help_center.vue